import React, { useMemo, Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";

import { ACTION as CHAT_ACTIONS } from "../../../redux/chat";
import NotFoundMessage from "../../../components/not-found-message";
import ChatMenuMobile from "../../../components/chat-menu-mobile";

import StyledChatPage from "./styles";

const ChatHomePage = () => {
  const { chatList, init } = useSelector((state) => state.chat);
  const finalChats = useMemo(() => chatList, [chatList]);

  if (!init) {
    return null;
  }

  return (
    <StyledChatPage>
      <div className="chat-home-page">
        <div className="background" />

        <Suspense>
          <ChatMenuMobile
            chats={finalChats}
            FallbackComponent={NotFoundMessage}
            fallbackProps={{
              message: "Mmmmmm.... Parece que no tienes ningún chat",
              Icon: QuestionMarkIcon,
            }}
          />
        </Suspense>
      </div>
    </StyledChatPage>
  );
};

export default ChatHomePage;
